import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

interface ShiftsWorkedRowProps {
  label: string;
  value: number;
}

export function ShiftsWorkedRow(props: ShiftsWorkedRowProps) {
  const { label, value } = props;

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "baseline" }}>
      <Text variant="body1">{label}</Text>
      <Text semibold variant="h4">
        {value}
      </Text>
    </Stack>
  );
}
